//Components
import AssessmentTemplateList from './AssessmentTemplateList';
import AlertSaveButton from '../../../../button/AlertSaveButton';
import Module from '../../../../../components/layout/Module';

//Other dependencies
import { useNavigate, useMatch } from 'react-router-dom';
import { resetState } from '../../../../../store/actions/dataEntryTemplateGeneratorActions';
import { useDispatch, useSelector } from 'react-redux';

const AssessmentTemplates = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const match = useMatch('/generator/assessment-templates');
  const url = match ? match.pathname : '';
  const permissions = useSelector((state) => state?.session?.permissions?.templateassessmentgenerator || {});
  const currentModule = 'templateassessmentgenerator';

  const redirect = (redirectTo) => {
    navigate(`${url}/${redirectTo}`);
  };

  const onCreateTemplate = () => {
    dispatch(resetState());
    redirect('dashboard/data-entry/generator/assessment-templates/add');
  };

  return (
    <Module>
      <Module.Header
        moduleName={currentModule}
        title='Assessment Templates'
        titleLink={'/dashboard/data-entry/generator/assessment-templates'}
      >
        <div className='flex justify-end items-center gap-2'>
          {permissions?.create && (
            <AlertSaveButton
              submodule={currentModule}
              icon='circle-check'
              title='Create Template'
              color='secondary'
              onDontSave={onCreateTemplate}
            />
          )}
        </div>
      </Module.Header>
      <Module.Body>
        <AssessmentTemplateList />
      </Module.Body>
    </Module>
  );
};

export default AssessmentTemplates;
